import {takeLatest, put} from 'redux-saga/effects';
import * as API from '../api/api';
import * as ApiFace from '../api/face';

import {
  FETCH_POST,
  FETCH_POST_SUCCESS,
  FETCH_POST_FAIL,
} from '../config/constant';

function* getPosts(action) {
  try {
    const {posts, post, flag} = action;

    let data;
    if (post) {
      data = posts.slice();

      switch (flag) {
        case 0: // enable post
          let index = data.findIndex(d => d.id == post.id);
          if (index < 0) return
          data[index].approve = true;
          
          yield API.update_post_field(post.id, 'approve', true)

          break;
        case 1: // delete post
          data = data.filter(d => d.id !== post.id);
          yield API.delete_post(post.id);
          yield ApiFace.remove_model_img(post.uid, post.imageID);
          break;
        default:
          break;
      }
    } else {
      data = yield API.get_posts();
    }

    yield put({
      type: FETCH_POST_SUCCESS,
      posts: data,
    });
  } catch (error) {
    console.log('saga posts:', error);
    yield put({type: FETCH_POST_FAIL});
  }
}
export function* watchPosts() {
  yield takeLatest(FETCH_POST, getPosts);
}
